import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useTracking } from "react-tracking";
import { catalogCiiuCleanSearchText, catalogCiiuStartDelete, cleanCatalogCiiuLevel1, cleanCatalogCiiuLevel2, cleanCatalogCiiuLevel3, cleanCatalogCiiuLevel4, cleanCatalogCiiuLevel5, cleanSearchingCatalogCiiusPaginated, selectCatalogCiiuLevel1, selectCatalogCiiuLevel2, selectCatalogCiiuLevel3, selectCatalogCiiuLevel4, selectCatalogCiiuLevel5, selectCatalogCiius, startLoadingCatalogCiiuByParent, startLoadingCatalogCiiusByLevel1, startLoadingCatalogCiiusNoLevel6, startLoadingCatalogCiiusPaginated, startSearchingCatalogCiiusPaginated } from "../../app/actions/catalogCiiuActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsCatalogCiius from "../generic-nav-bar/NavbarIconsCatalogCiius";
import SearchBackCatalogCiiu from "../generic-search/SearchBackCatalogCiiu";
import ReactPaginateComponent from "../generic-ui/ReactPaginateComponent";
import SimpleSelect from "../generic-ui/Select";
import TableCatalogCiius from "./TableCatalogCiius";

const ID_FORM = "admin-ciiu";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogCiius = () => {
  debugLogPages(':: ListCatalogCiius');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogCiiusS, catalogCiiusP, totalPagesP, totalPagesS, currentPageS,
    listCatalogCiiusLevel1, listCatalogCiiusLevel2, listCatalogCiiusLevel3,
    listCatalogCiiusLevel4, listCatalogCiiusLevel5
  } = useSelector((state) => state.catalogCiiu);


  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [catalogCiiuLevel1, setCatalogCiiuLevel1] = useState("");
  const [catalogCiiuLevel2, setCatalogCiiuLevel2] = useState("");
  const [catalogCiiuLevel3, setCatalogCiiuLevel3] = useState("");
  const [catalogCiiuLevel4, setCatalogCiiuLevel4] = useState("");
  const [catalogCiiuLevel5, setCatalogCiiuLevel5] = useState("");
  const [, setCatalogCiiuLevel6] = useState("");

    const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCatalogCiiusPaginated());
    dispatch(catalogCiiuCleanSearchText());
    //Load Data

    dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingCatalogCiiusNoLevel6())

    dispatch(startLoadingCatalogCiiusByLevel1(1));
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogCiius", method: "onEditRow", event: "EditCatalogCiius-Clicked" });

    dispatch(selectCatalogCiius(row));
    if (catalogCiiusS?.length > 0) {
      navigate("/admin-ciiu/edit-ciiu", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-ciiu/edit-ciiu");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogCiius", method: "onDeleteRow", event: "DeleteCatalogCiius-Clicked" });
    dispatch(catalogCiiuStartDelete(row.id));
  };

  const onPageChangeReactPaginate = (pageClick) => {
    const pageClickRP = pageClick && pageClick.selected + 1

    if (catalogCiiusS && catalogCiiusS.length > 0) {
      dispatch(startSearchingCatalogCiiusPaginated(searchText, pageClickRP - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogCiiusPaginated(pageClickRP - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogCiiusS && catalogCiiusS.length > 0) {
      dispatch(startSearchingCatalogCiiusPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogCiiusPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const handleChangeCiiuLevel1 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);

      if (event.code === 0) {
        setCatalogCiiuLevel1(event);
        dispatch(cleanCatalogCiiuLevel1());
        dispatch(selectCatalogCiiuLevel1(event));

        setCatalogCiiuLevel2("");
        setCatalogCiiuLevel3("");
        setCatalogCiiuLevel4("");
        setCatalogCiiuLevel5("");
        setCatalogCiiuLevel6("");

      } else {
        setCatalogCiiuLevel1(event);
        dispatch(cleanCatalogCiiuLevel1());
        dispatch(selectCatalogCiiuLevel1(event));

        setCatalogCiiuLevel2("");
        setCatalogCiiuLevel3("");
        setCatalogCiiuLevel4("");
        setCatalogCiiuLevel5("");
        setCatalogCiiuLevel6("");

        dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, event));
        dispatch(startLoadingCatalogCiiuByParent(event.id, 2));
      }
    } else {
      setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(cleanCatalogCiiuLevel1());
      setCatalogCiiuLevel1("");
      setCatalogCiiuLevel2("");
      setCatalogCiiuLevel3("");
      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage));
    }
  };

  const handleChangeCiiuLevel2 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogCiiuLevel2(event);

      dispatch(cleanCatalogCiiuLevel2());

      dispatch(selectCatalogCiiuLevel2(event));

      setCatalogCiiuLevel3("");
      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogCiiuByParent(event.id, 3));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(cleanCatalogCiiuLevel2());
      setCatalogCiiuLevel2("");
      setCatalogCiiuLevel3("");
      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, catalogCiiuLevel1));

    }
  };

  const handleChangeCiiuLevel3 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogCiiuLevel3(event);

      dispatch(cleanCatalogCiiuLevel3());

      dispatch(selectCatalogCiiuLevel3(event));

      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogCiiuByParent(event.id, 4));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);



      dispatch(cleanCatalogCiiuLevel3());
      setCatalogCiiuLevel3("");
      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, catalogCiiuLevel2));

    }
  };

  const handleChangeCiiuLevel4 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);




      setCatalogCiiuLevel4(event);

      dispatch(cleanCatalogCiiuLevel4());

      dispatch(selectCatalogCiiuLevel4(event));

      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogCiiuByParent(event.id, 5));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(selectCatalogCiiuLevel4(event));
      setCatalogCiiuLevel4("");
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, catalogCiiuLevel3));

    }
  };

  const handleChangeCiiuLevel5 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogCiiuLevel5(event);

      dispatch(cleanCatalogCiiuLevel5());

      dispatch(selectCatalogCiiuLevel5(event));

      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogCiiuByParent(event.id, 6));
    } else {
      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);



      dispatch(cleanCatalogCiiuLevel5());
      setCatalogCiiuLevel5("");
      setCatalogCiiuLevel6("");

      dispatch(startLoadingCatalogCiiusPaginated(pageInitial, itemsPerPage, catalogCiiuLevel4));

    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <>
      <NavbarIconsCatalogCiius page={"listCatalogCiius"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">
        <div className="row">

          {/* catalogCiiuId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level1`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCiiuLevel1}
                classNamePrefix="select"
                name="catalogCiiuLevel1"
                value={catalogCiiuLevel1}
                options={listCatalogCiiusLevel1}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* Level2 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level2`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCiiuLevel2}
                classNamePrefix="select"
                name="catalogCiiuLevel2"
                value={catalogCiiuLevel2}
                options={listCatalogCiiusLevel2}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

          {/* Level3 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level3`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCiiuLevel3}
                classNamePrefix="select"
                name="catalogCiiuLevel3"
                value={catalogCiiuLevel3}
                options={listCatalogCiiusLevel3}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

          {/* Level4 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level4`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCiiuLevel4}
                classNamePrefix="select"
                name="catalogCiiuLevel4"
                value={catalogCiiuLevel4}
                options={listCatalogCiiusLevel4}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

          {/* Level5 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level5`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCiiuLevel5}
                classNamePrefix="select"
                name="catalogCiiuLevel5"
                value={catalogCiiuLevel5}
                options={listCatalogCiiusLevel5}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

        </div>
      </div>

      <hr className="line-hr" />

      <SearchBackCatalogCiiu 
        searchText={searchText} 
        setSearchText={setSearchText} 
        itemsPerPage={itemsPerPage} 
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
        />

      {catalogCiiusS && catalogCiiusS.length > 0 ? (
        <TableCatalogCiius data={catalogCiiusS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogCiius data={catalogCiiusP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogCiiusS && catalogCiiusS.length > 0 ? (
          <ReactPaginateComponent
            totalPages={totalPagesS}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        ) : (
          <ReactPaginateComponent
            totalPages={totalPagesP}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogCiius;
